export const GET_ALL_USERS = () => `/data/users`; ////// will remove soon
export const GET_USER_DETAILS = (id) => `/data/user`; ////// will remove soon

export const BASE_URL = process.env.REACT_APP_API;
export const BACKEND_URL = process.env.REACT_APP_BACKEND;
export const urlUserLogin = BASE_URL + "auth/login";
export const urlRegistrationList = BASE_URL + "admin/get_registrations";
export const urlGetPrograms = BASE_URL + "admin/get_programs";
export const urlGetParticipant = BASE_URL + "admin/get_participants";
export const urlGetParticipantByLabel =
  BASE_URL + "admin/get_participants_label";
export const urlAvailableParticipant =
  BASE_URL + "admin/get_available_participant";
export const urlRegistrationDetailByGroup =
  BASE_URL + "admin/get_registration_group_detail";
export const urlRegistrationTransactionByGroup =
  BASE_URL + "admin/get_registration_transaction_group_detail";
export const urlRegistrationGroup = BASE_URL + "admin/get_registration_group";
export const urlRegistrationTransaction = BASE_URL + "admin/get_registration_transaction";
export const urlUpdateRegInfo = BASE_URL + "admin_registration/update_reg_info";
export const urlUpdateCampRegInfo = BASE_URL + "admin_registration/update_camp_reg_info";
export const urlDeleteRegInfo = BASE_URL + "admin_registration/delete_reg_info";
export const urlGetDivisionAll = BASE_URL + "admin/get_division_all";
export const urlGetDivisionSchedule = BASE_URL + "admin/get_division_schedule";
export const urlGetDivisionTree = BASE_URL + "admin/get_division_tree";
export const urlGetDivisionFilters = BASE_URL + "admin/get_division_filter";
export const urlGetDivision = BASE_URL + "admin/get_division";
export const urlCreateDivisionFromReg =
  BASE_URL + "admin/create_division_from_registration";
export const urlCreateDivision = BASE_URL + "admin/create_division";
export const urlUpdateDivision = BASE_URL + "admin/update_division";
export const urlGetAvailableTeamList = BASE_URL + "admin/get_available_team";
export const urlGetTeamList = BASE_URL + "admin/get_team";
export const urlCreateTeam = BASE_URL + "admin/create_team";
export const urlUpdateTeam = BASE_URL + "admin/update_team";
export const urlDeleteDivision = BASE_URL + "admin/delete_division";
export const urlDeleteTeam = BASE_URL + "admin/delete_team";
export const urlCreateBeclutchTeam =
  BASE_URL + "admin/create_beclutch_team_4club";
export const urlAddRoster = BASE_URL + "admin/add_roster";
export const urlCreateRosterInvitation = BASE_URL + "create/invite_roster";
export const urlUpdateRosterInvitation =
  BASE_URL + "admin/update_roster_invitation";
export const urlDeleteRoster = BASE_URL + "admin/delete_roster";
export const urlSendMessageGroup = BASE_URL + "admin/send_message_group";
export const urlSendMessage = BASE_URL + "admin/send_message";
export const urlGetMessageList = BASE_URL + "admin/get_messages";
export const urlGetMessageDetailList = BASE_URL + "admin/get_messages_detail";
export const urlGetLocation = BASE_URL + "setting/get_locations";
export const urlAddLocation = BASE_URL + "setting/create_location_info";
export const urlUpdateLocation = BASE_URL + "setting/update_location_info";
export const urlGetScheduleBaseInfo = BASE_URL + "admin/get_schedule_base";
export const urlGetScheduleList = BASE_URL + "admin/get_schedule_list";
export const urlCreateSchedule = BASE_URL + "admin/create_schedule";
export const urlGetSetupInfo = BASE_URL + "admin/get_setup_info";
export const urlSetupSchedule = BASE_URL + "admin_schedule/setup_schedule";
export const urlUpdateStagedList = BASE_URL + "admin/update_stage_list";
export const urlDeleteStage = BASE_URL + "admin/delete_stage";
export const urlGetStagedGames = BASE_URL + "admin/get_staged_games";
export const urlCreateEvent =
  BASE_URL + "calendar/create_new_games_4club_league";
export const urlUpdateEvent = BASE_URL + "calendar/update_game_4club_league";
export const urlCancelEvent = BASE_URL + "calendar/cancel_game_4club_league";
export const urlDeleteEvent = BASE_URL + "calendar/delete_game_4club_league";
export const urlCreateClubEvent = BASE_URL + "admin/setup_one_schedule";
export const urlGetEventList = BASE_URL + "calendar/get_calendar_all_teams";
export const urlGetGameResult = BASE_URL + "calendar/get_game_score";
export const urlUpdateGameScore = BASE_URL + "calendar/update_game_score";
export const urlGetStandingList = BASE_URL + "admin/get_standing_list";
export const urlCreatePractice = BASE_URL + "calendar/create_new_practice";
export const urlCancelPractice = BASE_URL + "calendar/cancel_practice";
export const urlDeletePractice = BASE_URL + "calendar/remove_practice_game";

export const urlGetActivityList = BASE_URL + "auth/productions";
export const urlGetWebpageGroups = BASE_URL + "admin/get_webpage_groups";
export const urlSaveRegistrationGeneral = BASE_URL + "admin/save_registration_general";
export const urlSaveRegistrationMain = BASE_URL + "admin/save_registration_main";
export const urlSaveRegistrationWaiver = BASE_URL + "admin/save_registration_waiver";
export const urlSaveRegistrationCheckout = BASE_URL + "admin/save_registration_checkout";
export const urlSaveHomePageInfo = BASE_URL + "admin/save_homepage_info";
export const urlSaveWizardRegistration = BASE_URL + "wizard/save_wizard_registration";
export const urlSaveRegistrationGroup =
  BASE_URL + "admin/save_registration_group";
export const urlChangeRegistrationStatus =
  BASE_URL + "admin/update_registration_status";
export const urlGetRegistrationSettings =
  BASE_URL + "admin/get_registration_settings";
export const urlGetTransactionDetail = BASE_URL + "admin/get_transaction_detail";
export const urlGetTransactionsList = BASE_URL + "admin/get_transactions_list";
export const urlUpdateTransactionPayStatus = BASE_URL + "admin/update_transaction_pay_status";
export const urlGetRegistrationTotals = BASE_URL + "admin/get_registration_totals";
export const urlGetRegistrationTotalParticipants = BASE_URL + "admin/get_registration_total_participants";
export const urlGetInvoiceData = BASE_URL + "admin/get_invoice_data";

// Payment transaction operations
export const urlGetRegistrationPaymentSettings = BASE_URL + "camp/get_registration_payment_settings";
export const urlVoidTransaction = BASE_URL + "payments/forte/void";
export const urlRefundTransaction = BASE_URL + "payments/forte/refund";
export const urlStaxVoidTransaction = BASE_URL + "payments/stax/void";
export const urlStaxRefundTransaction = BASE_URL + "payments/stax/refund";

// Facility Application APIs
export const urlGetFacilityApplications = BASE_URL + "admin/get_facility_applications";
export const urlApproveFacilityApplication = BASE_URL + "admin/approve_facility_application";
export const urlRejectFacilityApplication = BASE_URL + "admin/reject_facility_application";
export const urlDeleteFacilityApplication = BASE_URL + "admin/delete_facility_application";
export const urlCreateFacilityReservation = BASE_URL + "admin/create_facility_reservation";
export const urlGetFacilityCalendar = BASE_URL + "admin/get_facility_calendar";

export const urlAddUIForm = BASE_URL + "admin/add_ui_form";
export const urlUpdateUIForm = BASE_URL + "admin/update_ui_form";
export const urlDeleteUIForm = BASE_URL + "admin/delete_ui_form";
export const urlGetUIForms = BASE_URL + "admin/get_ui_forms";
export const urlGetReportNames = BASE_URL + "custom_reports/get_report_names";
export const urlRunReport = BASE_URL + "custom_reports/get_custom_report_data";
export const urlGetBadges = BASE_URL + "admin/get_badges";
export const urlSaveBadge = BASE_URL + "admin/save_badge";
export const urlDeleteBadge = BASE_URL + "admin/delete_badge";

// Column Preferences APIs
export const urlGetColumnPreferences = BASE_URL + "admin_registration/get_column_preferences";
export const urlSaveColumnPreferences = BASE_URL + "admin_registration/save_column_preferences";

// Menu Permissions APIs
export const urlGetMenuPermissions = BASE_URL + "admin/get_menu_permissions";
export const urlUpdateMenuPermission = BASE_URL + "admin/update_menu_permission";

// Club website + homepage content
export const urlGetClubSite = BASE_URL + "admin/get_club_site";
export const urlSaveClubSite = BASE_URL + "admin/save_club_site";
export const urlGetClubHomepage = BASE_URL + "admin/get_club_homepage";
export const urlSaveClubHomepage = BASE_URL + "admin/save_club_homepage";
export const urlDeleteClubHomepage = BASE_URL + "admin/delete_club_homepage";
export const urlGetSubdomainFiles = BASE_URL + "admin/get_subdomain_files";

export const urlPhotoUpload = BACKEND_URL + "photo-upload.html";
export const urlBadge = BACKEND_URL + "uploads/badge_photos";
export const urlUploadPhoto = BASE_URL + "admin/upload_photo";
export const urlGetProfileInfo = "";
export const urlUpdateProfileInfo = "";

// Audience APIs
export const urlGetAudienceList = BASE_URL + "admin/get_audiences";
export const urlCreateAudience = BASE_URL + "admin/create_new_audience";
export const urlUpdateAudience = BASE_URL + "admin/edit_audience";
export const urlDeleteAudience = BASE_URL + "admin/delete_audience";
// Email Campaign APIs
export const urlSendEmailCampaign = BASE_URL + "admin/send_email_campaign";
export const urlGetEmailCampaigns = BASE_URL + "admin/get_email_campaigns";
export const urlGetEmailCampaignDetail = BASE_URL + "admin/get_email_campaign_detail";
